import {getDefaultState} from '@/store/modules/bs_set/state'

export const SET_DEMO = 'SET_DEMO'
export const RESET_STATE = 'RESET_STATE'

export default {
  [RESET_STATE](state) {
    Object.assign(state, getDefaultState())
  },
  [SET_DEMO](state, demo) {
    state.demo = demo
  }
}